import { AppBar, Box, Link, Toolbar } from '@mui/material';
import Image from "next/image";
import bonavendiLogo from 'pages/../../public/bonavendi_logo_pagetop_orangegrey_de.png';
import ProductSearch from 'components/common/product-search/ProductSearch';
import { useRouter } from 'next/router';
import TransactionNavbarItem from 'components/react-app/TransactionNavbarItem';
import CartNavbarItem from 'components/react-app/CartNavbarItem';
import LoginNavbarItem from 'components/react-app/LoginNavbarItem';
import NavbarDrawerItem from 'components/react-app/NavbarDrawerItem';

export interface IMenuItem {
  iconKey?: string;
  title?: string;
  href?: string;
}

interface NavbarProps {
  showProductSearch?: boolean;
}

const Navbar = ({ showProductSearch }: NavbarProps) => {
  const router = useRouter();

  return (
    <AppBar position="fixed">
      <Toolbar
        sx={{
          minHeight: { xs: showProductSearch ? 112 : 56, sm: 64 },
          flexWrap: {
            xs: showProductSearch ? 'wrap' : 'nowrap',
            sm: 'nowrap',
          },
          alignItems: { xs: 'center' },
          justifyContent: { xs: 'center' },
        }}
      >
        <Box
          sx={{
            flex: { xs: 1, sm: 0 },
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <NavbarDrawerItem />
          <Box
            sx={{
              flex: 1,
              justifyContent: 'center',
              minWidth: 200,
              textAlign: { xs: 'center', sm: 'left' },
            }}
          >
            <Link underline="none" href="/" color="inherit">
              <Image
                width="200"
                src={bonavendiLogo}
                alt={'bonavendi Logo'}
                quality="100"
                priority
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  objectFit: "contain"
                }} />
            </Link>
          </Box>
        </Box>
        {!router.isFallback && showProductSearch && (
          <Box sx={{ flex: 1, display: 'flex', order: { xs: 4, sm: 1 } }}>
            <ProductSearch />
          </Box>
        )}
        {!showProductSearch && <Box sx={{ flex: { xs: 0, sm: 1 } }}></Box>}
        <Box
          sx={{
            display: 'flex',
            justifyContent: { xs: 'center' },
            alignItems: { xs: 'center' },
            order: { xs: 1, sm: 2 },
          }}
        >
          <CartNavbarItem />
        </Box>
        <Box
          sx={{ display: { xs: 'none', lg: 'flex' }, order: { xs: 2, sm: 3 } }}
        >
          <TransactionNavbarItem />
        </Box>
        <Box sx={{ display: 'flex', order: { xs: 3, sm: 4 } }}>
          <LoginNavbarItem />
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;
